export default __webpack_public_path__ + "static/silver_tier-d1748eab70b6015de267f906d8956696.png";